import {
  RESET_CLIENT_INFO,
  CLIENT_INFO_ERROR,
  GET_CLIENT_INFO,
  SET_CLIENT_INFO,
  SET_CURRENT_CHAT_DATA,
} from "./actionTypes";

export const resetClientInfo = (reset) => {
  return {
    type: RESET_CLIENT_INFO,
    payload: reset,
  };
};
export const clientInfoError = (error) => {
  return {
    type: CLIENT_INFO_ERROR,
    payload: error,
  };
};

export const getClientInfo = (chatId) => {
  return {
    type: GET_CLIENT_INFO,
    payload: chatId,
  };
};
export const setClientInfo = (chatId, data) => {
  data = data.length > 0 ? data[0] : data;
  return {
    type: SET_CLIENT_INFO,
    payload: { chatId, data },
  };
};
export const setCurrentChatData = (conversationId, tabId, consumerId) => {
  return {
    type: SET_CURRENT_CHAT_DATA,
    payload: { conversationId, tabId, consumerId },
  };
};
